export default __webpack_public_path__ + "static/media/Garage.6cd2e264.svg";